<template>
  <div class="company">
    <div class="top">
      <img src="https://gwsite-1302681310.cos.ap-beijing.myqcloud.com/assets/about/banner1.jpg"/>
      <div class="content">
      </div>
    </div>
    <div class="contain">
      <div class="main">
        <div class="ban-1">
          <div class='hometitlediv'>
            <div class='hometitle'>关于我们</div>
            <div class='hometitleline'></div>
          </div>
          <div class="homeitem1 contain">
            <div class="main">
              <el-row :gutter="10">
                <el-col :span="14" class="left">
                  <p class="title">公司简介</p>
                  <div class="line"></div>
                  <p class="introduce">顺风大运目标是打造专业、高效、智能、便捷的大件智能专车平台。</p>
                  <p class="introduce">
                    顺风大运是基于大数据智能调度，把无序的物流变为时间有序、空间有序，实现计划式的车辆闭环线路；目的是降低空驶率，降低车辆运营成本，进而提升车辆有效运输效率，所创造的超额利润空间由车方、货方、平台分享。通过专车智能调度平台，降低了空驶率，提升了车辆使用效率，降低了设备运输价格，实现了企业、司机、平台三方收益。
                  </p>
                  <p class="introduce">
                    时代的趋势、市场的机遇、政策的东风、菁英的团队都构建着顺风大运的项目天时地利人和。优秀的创始团队，协同资本的助力，一起打造顺风大运的光辉未来！未来已来！聚力前行！
                  </p>
                </el-col>
                <el-col :span="10">
                  <img src="https://gwsite-1302681310.cos.ap-beijing.myqcloud.com/assets/about/ab-1.jpg" width="100%"/>
                </el-col>
              </el-row>
              <div class="ban-2">
                <p class="title">公司愿景</p>
                <div class="line"></div>
                <p class="content">
                  打造专业、高效、智能、便捷的大件专车智能服务平台
                </p>
              </div>
              <div class="ban-2">
                <p class="title">企业文化</p>
                <div class="line"></div>
                <p class="content">
                  客户第一、互利互赢、阳光诚信、公平公正、结果导向、迭代创新、追求卓越！
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class='hometitlediv news-title'>
          <div class='hometitle'>企业新闻</div>
          <div class='hometitleline'></div>
        </div>
        <el-row class="content" :gutter="10">
          <el-col :span="12" v-for="(item,index) in newsList" :key="index">
            <div @click="openClick(item)" class="news-card"> <!-- 新增外层容器 -->
              <el-row class="news"> <!-- 改为flex布局 -->
                <el-col :span="7" class="news-img-wrap"> <!-- 图片容器 -->
                  <img :src="item.img" class="news-img"/>
                </el-col>
                <el-col :span="17" class="news-item">
                  <p class="tit">{{ item.title }}</p>
                  <p class="detail">{{ item.detail }}</p>
                  <p class="time">{{ item.time }}</p>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "company",
  data() {
    return {
      newsList: [
        {
          url: 'https://mp.weixin.qq.com/s/WYaAiVGOvNUDulxiJ5SDqg',
          img: 'https://gwsite-1302681310.cos.ap-beijing.myqcloud.com/assets/solution/yh.jpg',
          title: '顺风大运获涌铧资本领投B轮，持续领跑大件智能物流',
          detail: '近日，设备物流智能调度平台「顺风大运」完成数千万人民币B轮融资，本轮由涌铧资本领投。融资将主要用于产品升级、研发投入与算法迭代，进一步推动业务发展。',
          time: '2026-01-23',
          type: 1
        },
        {
          url: 'https://m.sohu.com/a/960788919_121911829?strategyid=00014',
          img: 'https://minipro-1302681310.cos.ap-beijing.myqcloud.com/zyt/web/20251202.png',
          title: '《科创为核、诚信为基！智运通开启品牌创新新征程》-上搜狐网，查看更多精彩内容',
          detail: '12月2日，崛起的民族品牌选题会在北京顺利举行。智运通（北京）科技有限责任公司紧跟时代号召，勇担时代重任，弘扬企业家精神，将品牌建设作为推动企业高质量发展的关键抓手，该公司负责人王森华受邀参加此次选题会，并成功入围，开启品牌创新战略新征程。',
          time: '2025-12-02',
          type: 1
        },
        {
          url: '/newsDetail/0',
          img: 'https://gwsite-1302681310.cos.ap-beijing.myqcloud.com/assets/team/new-1.png',
          title: '工程机械租赁行业大咖论道逆境破局，加速重构市场新格局',
          detail: '2021年3月25-26日，以"逆境破局，加速重构！"为主题的2020年中国工程机械工业协会工程机械租赁分会年会在四川成都市隆重举行。本次会议是由中国工程机械工业协会指导，中国工程机械工业协会工程机械租赁分会主办。会议深度剖析当前形势下工程机械租赁面临的主要问题，共同探讨如何推进行业高质量发展，助力制造企业、租赁企业把握机遇，展望未来。',
          time: '2021-03-26',
          type: 0
        },
        {
          url: 'http://www.jiaotongwang.com.cn/index/wuliu/2024/0420/512468.html',
          img: 'http://admin-plat-1302681310.cos.ap-beijing.myqcloud.com/test/dateundefined/171375506875620240422-110422.jpg',
          title: '中国水利电力物资流通协会 2024 年度工作会议在长沙圆满举行',
          detail: '中国交通在线  (沈君波)  4 月 18 日上午，中国水利电力物资流通协会 2024 年度工作会议于湖南长沙成功举办。此次会议全面总结了 2023 年的工作，并对 2024 年的工作进行了详细部署。会议聚焦工作重点，深入分析了行业发展现状，通过加强交流与集思广益，凝聚起了团结奋进、积极向上的强大精神力量。近 200 名来自全国各地的会员代表参加了此次会议，交通运输部公路局路网管理处以及湖南省交通厅政务服务处的相关领导和嘉宾也应邀出席。',
          time: '2024-04-20',
          type: 1
        },
        {
          url: 'https://mp.weixin.qq.com/s/GnEcVKrlxUBbG9BFlsB1dQ',
          img: 'http://admin-plat-1302681310.cos.ap-beijing.myqcloud.com/test/date/balanceSettlement/171539447571220240511-102745.jpg',
          title: '潘智勇会长一行赴智运通调研',
          detail: '2024年5月7日，潘智勇会长一行到智运通（北京）科技有限责任公司进行调研。智运通公司王森华董事长就公司成立的背景、组织架构、业务板块以及未来愿景向潘会长做了介绍。',
          time: '2024-05-10',
          type: 1
        },
      ]
    }
  },
  methods: {
    openClick(e) {
      if (e.type === 0) {
        this.$router.push(e.url);
      } else {
        window.open(e.url, '_blank');
      }
    }
  }
}
</script>

<style lang="less">
.company {
  .hometitlediv {
    position: relative;
    float: left;
    width: 100%;
    height: auto;
    margin-top: 0.80rem;
  }

  .news-title {
    margin-bottom: 70px;
  }

  .hometitle {
    position: relative;
    float: left;
    width: 100%;
    height: 0.56rem;
    font-size: 0.30rem;
    line-height: 0.56rem;
    font-weight: bold;
    text-align: center;
    color: #222;
  }

  .hometitleline {
    position: relative;
    float: left;
    width: 0.34rem;
    height: 0.04rem;
    margin-left: 50%;
    transform: translateX(-50%);
    background-color: #0274F6;
  }

  .hometitledesc {
    position: relative;
    float: left;
    width: 100%;
    height: 0.26rem;
    font-size: 0.16rem;
    line-height: 0.26rem;
    color: #222;
    text-align: center;
    margin-top: 0.10rem;
    font-weight: normal;
  }

  .top {
    width: 100%;
    position: relative;

    img {
      width: 100%;
    }

    .content {
      .homediv {
        position: relative;
        float: left;
        width: 100%;
        height: auto;
        overflow: hidden;

        .main {
          padding-top: 1.06rem;
          font-size: 12px;

          .title {
            text-align: left;
            font-size: 20px;
            font-weight: bold;
            color: #222222;
            line-height: 1.2em;
            margin: 0;
          }

          .line {
            width: 34px;
            height: 2px;
            background: #0274F6;
            margin-top: 20px;
            margin-bottom: 20px;
          }

          .left {
            text-align: left;

            .introduce {
              font-size: 18px;
              font-weight: 400;
              color: #222;
              line-height: 1.5em;
              margin-bottom: 0.15rem;
            }
          }

          .ban-2 {
            text-align: left;
            margin-top: 0.35rem;

            .content {
              font-size: 18px;
              font-weight: 400;
              color: #222;
              line-height: 0.3rem;
            }
          }
        }
      }

      .homediv .homeitem1 {
        position: relative;
        float: left;
        width: 12.20rem;
        height: auto;
        margin-left: 50%;
        padding-bottom: 1.50rem;
        transform: translateX(-50%);
        margin-top: 0.30rem;
      }

      .homediv .homeitem1image {
        position: relative;
        float: left;
        width: auto;
        height: 5.55rem;
        margin-left: 50%;
        margin-top: 0.10rem;
        transform: translateX(-50%);
      }
    }
  }

  .contain {
    min-width: 1200px;
    .main {
      font-size: 12px;

      .title {
        text-align: left;
        font-size: 20px;
        font-weight: bold;
        color: #222222;
        line-height: 1.2em;
        margin: 0;
      }

      .line {
        width: 34px;
        height: 2px;
        background: #0274F6;
        margin-top: 20px;
        margin-bottom: 20px;
      }

      .left {
        text-align: left;

        .introduce {
          font-size: 18px;
          font-weight: 400;
          color: #222;
          line-height: 1.5em;
          margin-bottom: 0.15rem;
        }
      }

      .ban-2 {
        text-align: left;
        margin-top: 0.35rem;

        .content {
          font-size: 18px;
          font-weight: 400;
          color: #222;
          line-height: 0.3rem;
        }
      }
    }
  }

  .homeitem1 {
    position: relative;
    float: left;
    width: 12.20rem;
    height: auto;
    margin-left: 50%;
    padding-bottom: 1.50rem;
    transform: translateX(-50%);
    margin-top: 0.30rem;
  }

  .content {
    font-size: 14px;
    text-align: left;
    padding-bottom: 20px;

    // 新闻卡片外层容器
    .news-card {
      display: block;
      height: 100%;
    }

    // 核心：新闻行改为flex布局，强制子元素等高
    .news {
      background: #F7F7F7;
      margin-bottom: 10px;
      display: flex; // 关键：Flex布局让子元素等高
      height: 100%; // 占满外层容器高度

      // 图片容器：高度100%，无内边距
      .news-img-wrap {
        height: 100%;
        padding: 0 !important; // 清除el-col默认padding
        margin: 0;

        // 图片铺满容器，保持比例
        .news-img {
          width: 100%;
          height: 100%;
          object-fit: cover; // 关键：图片铺满容器，裁剪多余部分
          display: block; // 清除图片底部空白
        }
      }

      .news-item {
        cursor: pointer;
        padding: 2% 17px 2% 26px; // 上下内边距对称
        text-align: left;
        display: flex;
        flex-direction: column; // 文字区域垂直布局
        justify-content: space-between; // 可选：文字均匀分布

        .tit {
          font-size: 20px;
          font-weight: 600;
          color: #222222;
          line-height: 37px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin: 0 0 8px 0; // 清除默认margin，控制间距
        }

        .detail {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          overflow: hidden;
          font-size: 16px;
          font-weight: 400;
          color: #222222;
          line-height: 22px;
          flex: 1; // 关键：让详情占满剩余空间，保证图片高度铺满
          margin: 0 0 16px 0;
        }

        .time {
          font-size: 16px;
          font-weight: 400;
          color: #999999;
          line-height: 22px;
          margin: 0; // 清除默认margin
        }
      }
    }
  }
}
</style>